<template>
  <div>
    <h3 class="title" :class="{mt12:mt12}" v-if="title">{{title}}</h3>
    <Row :gutter="16">
      <Col :span="slotSpan">
        <slot></slot>
      </Col>
      <Col :span="tableSpan">
        <template v-if="defaultTem&&data.length === 0">
          <div class="default-tem-warpper">
              <img src="@/assets/group.png">
              <div>暂无内容 </div>
          </div>
        </template>
        <template v-else>
            <Table
              :row-class-name="rowClassName"
              :columns="columns"
              :border="border"
              :data="data"
              :loading="loading"
              :height="height"
              @on-selection-change="select"
              @on-select="onSelect" ref="table"></Table>
            <div style="overflow:hidden" v-if="showPage">

              <Page :total="total" :size="size" :current="current" show-total transfer @on-change="changePage"
                    @on-page-size-change="changeSize" class="mt20 fr" v-if="showPage"
                    :page-size="pageSize"
              ></Page>
              <Select v-if="showSet" class="fr mr20 mt20" v-model="limit" :size="size" style="width:50px" @on-change="changeLimit">
                  <Option v-for="item in pageList" :value="item.value" :key="item.value">{{ item?item.text:'' }}</Option>
              </Select>
            </div>
        </template>
      </Col>
    </Row>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      columns: {
        type: Array,
        default: null
      },
      data: {
        type: Array,
        default: null
      },
      border: {
        type: Boolean,
        default: false
      },
      total: {
        type: Number,
        default: 0
      },
      size: {
        type: String,
        default: "small"
      },
      loading: {
        type: Boolean,
        default: true
      },
      current: {
        type: Number,
        default: 1,
      },
      tableSpan: {
        type: Number,
        default: 24
      },
      showPage: {
        type: Boolean,
        default: true

      },
      slotSpan: {
        type: Number,
        default: 24
      },
      mt12: {
        type: Boolean,
        default: true
      },
      showSet:{
        type: Boolean,
        default: false
      },
      // showPage:{
      //   type:Boolean,
      //   default:true
      // },
      height:{
        type:Number,
        default:null
      },
      pageSize:{
        type:Number,
        default:10
      },
      // 数据为空是，展示缺省图
      defaultTem:{
        type:Boolean,
        default:false
      },
      rowClassName: {
        type: Function,
        default: () => false
      }
    },
    data(){
      return {
        limit:10,
        pageList:[
          {
            text:10,
            value:10
          },
          {
            text:30,
            value:30
          },
          {
            text:50,
            value:50
          }
        ]
      }
    },
    methods: {
      changePage(n) {
        this.$emit('change-page', n);
      },
      changeSize(size) {
        this.$emit('change-size', size)
      },
      select(selection, row) {
        this.$emit('on-selection-change', selection, row)
      },
      onSelect(selection,row){
        this.$emit('on-select',selection,row)
      },
      changeLimit(value) {
        this.$emit('change-limit',value)
      }
    }
  }
</script>
<style scoped>
.default-tem-warpper{
  height: 200px;
  text-align: center;
  color: #D0D0D0;
  border-top:1px solid #dddee1;
}
.default-tem-warpper img{
  width: 65px;
  margin-top: 48px;
}
.default-tem-warpper div{
  width: 65px;
  margin: 0 auto;
  text-align: left;

}
</style>

